module.exports = __webpack_public_path__ + "img/map.3e24f967.svg";